<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { apiErrorMessage } from '@/composables/equipment/useEquipmentLookups';
import EquipmentModal from './EquipmentModal.vue';

const props = defineProps<{
  title: string;
  message: string;
  run: () => Promise<unknown>;
}>();
const emit = defineEmits<{ close: []; done: [] }>();

const { t } = useI18n({ useScope: 'global' });
const busy = ref(false);
const error = ref('');

// Le refus du serveur (409 : appareils actifs, maître d'un sous-groupe) s'affiche ici, la modale reste ouverte.
const confirm = async () => {
  busy.value = true;
  error.value = '';
  try {
    await props.run();
    emit('done');
  } catch (failure) {
    error.value = apiErrorMessage(failure, t('equipment.errors.generic'));
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <EquipmentModal :title="title" @close="emit('close')">
    <p>{{ message }}</p>
    <p v-if="error" class="eq-error" role="alert">{{ error }}</p>
    <template #footer>
      <button type="button" class="eq-btn" @click="emit('close')">
        {{ t('equipment.cancel') }}
      </button>
      <button
        type="button"
        class="eq-btn eq-btn--danger"
        :disabled="busy"
        @click="confirm"
      >
        {{ t('equipment.delete') }}
      </button>
    </template>
  </EquipmentModal>
</template>
